import Vue from 'vue';
export var event = new Vue();
